import path from 'path';
import { GetStaticPaths, GetStaticProps } from 'next';

import { getFilePathsInFolder, readFile } from '@collab/utils/files';

import { termsAndConditionsFolder } from 'libs/cms/common/paths';
import { serializeMdx } from 'libs/mdx/mdxSerializer';
import MdxLegalPage from 'pages/mdx/MdxLegalPage';
import { MdxPageProps } from 'types/pages';
import { MissingParams } from 'utils/slugs';

const termsOnIndexPath = 'oip-terms-and-conditions';

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = await getPaths();

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<MdxPageProps> = async ({
  params,
}) => {
  if (!params) throw new MissingParams();

  const slug = params.slug ?? termsOnIndexPath;
  const filePath = `${termsAndConditionsFolder}/${slug}.mdx`;
  const fileContent = await readFile(filePath);
  const mdxContent = await serializeMdx(fileContent);

  return {
    props: {
      mdxContent,
    },
  };
};

const getPaths = async () => {
  const paths = await getFilePathsInFolder(termsAndConditionsFolder);

  return paths.map((file) => {
    if (file.name === `${termsOnIndexPath}.mdx`) {
      return { params: { slug: undefined } };
    }

    return {
      params: { slug: [path.parse(file.name).name] },
    };
  });
};

export default MdxLegalPage;
